import React from 'react';
import { useTranslation } from 'react-i18next';
import { UiIcon } from 'ui-components';
import PropTypes from 'prop-types';
import {
  StyledSelectNativePlatforms,
  StyledToggleButton,
} from './SelectNativePlatforms.styles';

export default function SelectNativePlatforms({
  label,
  selectedPlatforms,
  onChange,
}) {
  const { t } = useTranslation();

  const nativePlatforms = [
    {
      label: t('common:eitaa'),
      id: 'eitaa_channel_post',
      icon: 'eitaa-colored',
    },
    { label: t('common:bale'), id: 'bale_channel_post', icon: 'bale-colored' },
    {
      label: t('common:rubika'),
      id: 'rubika_channel_post',
      icon: 'rubika-colored',
    },
  ];

  return (
    <StyledSelectNativePlatforms>
      <div>{label}</div>
      {nativePlatforms.map(({ label, id, icon }) => (
        <StyledToggleButton
          key={id}
          startIcon={<UiIcon src={icon} size={28} />}
          variant='outlined'
          color='primary'
          className={selectedPlatforms.includes(id) && 'checked'}
          onClick={() => onChange(id)}
        >
          {label}
        </StyledToggleButton>
      ))}
    </StyledSelectNativePlatforms>
  );
}

SelectNativePlatforms.propTypes = {
  selectedPlatforms: PropTypes.func,
  label: PropTypes.string,
  onChange: PropTypes.func,
};
